<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'App',
	components: {},
	watch: {
		// 监听路由变化
		$route(to) {
			this.setBgImage(to.path);
		}
	},
	mounted() {
		// 初始化时设置一次
		this.setBgImage(this.$route.path);
		let rootWidth = document.documentElement.clientWidth || document.body.clientWidth;
		// console.log(rootWidth, 'rootWidth123123')
		let rootDom = document.querySelector('html');
		// 1920默认是16px 
		rootDom.style.fontSize = rootWidth * 16 / 1920 + 'px';
		// console.log(rootDom.style.fontSize, 'eeeeeee123')

	},
	created() {

	},
	methods: {
		setBgImage(path) {

			const body = document.body;
			let bgUrl;

			if (path === '/' || path === '/login') {
				// 注意：背景图路径要通过 require 引入
				bgUrl = require('@/assets/images/Group_bj.png');
			} else {
				bgUrl = require('@/assets/images/BG.png');
			}

			body.style.backgroundImage = `url(${bgUrl})`;
			body.style.backgroundRepeat = 'no-repeat';
			body.style.backgroundPosition = 'center center';
			body.style.backgroundSize = 'cover';
			body.style.backgroundAttachment = 'fixed';
			body.style.backgroundColor = '#082f6a';
		}
	}
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #FFF;
	width: 100%;
	height: 100%;
}

body {
	margin: 0;
	padding: 0;
	color: #FFF;
	overflow: hidden;
	width: 100%;
	height: 100%;
}
</style>